import React from 'react'
import { Link } from 'react-router-dom'
import { getTimeZoneOffset } from '../../utils/js/time_helpers'
import { formatPeriodName } from '../../utils/js/nhl_helpers'
import { CSSTransitionGroup } from 'react-transition-group'
import AnimatedNumber from 'react-animated-number'
import { overrideTeamTricode, defaultLeagueLogo, removeSpecialChars } from 'utils/js/shared_helpers'

import useIsMobile from '../../context/IsMobileContext'

const TickerGame = ({ ticker, game, league, sport, index, tickerClass }) => {
    const { isMobileApp } = useIsMobile()
    let initAniDelay = 1 * `.${index}`

    // eslint-disable-next-line
    const formattedGameParams = reformatGameParams(game)

    const showClock =
        (sport === 'hockey' && formattedGameParams.new_status !== 'SO') ||
        sport === 'basketball' ||
        sport === 'football'

    let formatInningName = inning => {
        switch (inning) {
            case 1:
                return '1st'
            case 2:
                return '2nd'
            case 3:
                return '3rd'
            default:
                return inning + 'th'
        }
    }

    let formatQuarter = quarter => {
        switch (quarter) {
            case 1:
                return 'Q1'
            case 2:
                return 'Q2'
            case 3:
                return 'Q3'
            case 4:
                return 'Q4'
            case 5:
                return 'OT'
            default:
                return quarter - 4 + 'OT'
        }
    }

    let formatTime = (period, timestamp, game_type, clock) => {
        if (game.game_status === 'Pre-Game') {
            const timezones = {
                3.5: 'NT',
                4: 'AT',
                5: 'ET',
                6: 'CT',
                7: 'MT',
                8: 'PT',
            }

            let game_time = new Date(timestamp * 1000)
            let hours = game_time.getHours()
            let minutes = '0' + game_time.getMinutes()
            let user_offset = getTimeZoneOffset()

            let timezone = timezones[Math.abs(Math.floor(user_offset / 3600))] || ''
            let meridiem = hours >= 12 ? 'PM' : 'AM'
            return (
                ((hours + 11) % 12) + 1 + ':' + minutes.substr(-2) + ' ' + meridiem + ' ' + timezone
            )
        } else {
            if (game.game_status === 'Final') {
                if (sport === 'soccer') {
                    return clock
                }

                let lastPeriodLabeltoShow = ''
                if (league === 'nhl') {
                    let lastPeriodLabel = formatPeriodName(period, game_type)
                    lastPeriodLabeltoShow =
                        lastPeriodLabel === 'SO' || lastPeriodLabel.indexOf('OT') >= 0
                            ? ' (' + lastPeriodLabel + ')'
                            : ''
                }
                return 'Final' + lastPeriodLabeltoShow
            } else if (game.game_status === 'In-Progress') {
                if (sport === 'hockey') {
                    return formatPeriodName(period, game_type)
                } else if (sport === 'baseball') {
                    return formatInningName(period, game_type)
                } else if (sport === 'basketball' || sport === 'football') {
                    return formatQuarter(period)
                } else if (sport === 'soccer') {
                    return clock
                }
            } else {
                return game.game_status // Support for delays and cancellations.
            }
        }
    }

    if (ticker.games.length === 0) {
        return <div className="no_games">No Other {league} Games Today</div>
    } else {
        let basicQueryString = isMobileApp ? '?template=basic' : ''

        if (game.visiting_team.short_name === '') {
            game.visiting_team.img_url_90 = defaultLeagueLogo(game.visiting_team.img_url_90, league)
            game.visiting_team.short_name = 'TBD'
        }

        if (game.home_team.short_name === '') {
            game.home_team.img_url_90 = defaultLeagueLogo(game.home_team.img_url_90, league)
            game.home_team.short_name = 'TBD'
        }

        if (game.game_status === 'In-Progress' && showClock) {
            var clock_minutes = parseInt(game.clock.split(':')[0], 10)
            var clock_seconds = parseInt(game.clock.split(':')[1], 10)
        }

        return (
            <div
                className={`ticker__game ${tickerClass}`}
                style={{
                    transition: `transform .3s ${initAniDelay}s cubic-bezier(.32,1.07,.53,1.15), opacity .3s ${initAniDelay}s`,
                }}
            >
                <Link to={`${formattedGameParams.new_game_url}${basicQueryString}`}>
                    <CSSTransitionGroup
                        transitionName="ticker__backdropscore_ani"
                        transitionEnterTimeout={4200}
                        transitionLeaveTimeout={4200}
                    >
                        <div
                            key={game.home_team.score + game.visiting_team.score || 0}
                            className="scorebackdrop"
                        />
                    </CSSTransitionGroup>
                    <div className="game_status">
                        {game.game_status === 'In-Progress' &&
                            showClock &&
                            game.clock === '0:00' && <span>End &nbsp;</span>}

                        {formatTime(game.period, game.timestamp, game.type, game.clock)}

                        {game.game_status === 'In-Progress' && showClock && game.clock !== '0:00' && (
                            <span>
                                &nbsp;
                                <AnimatedNumber
                                    component="span"
                                    value={clock_minutes}
                                    style={{
                                        transition: '0.8s ease-out',
                                        transitionProperty: 'opacity',
                                    }}
                                    stepPrecision={0}
                                    duration={500}
                                    formatValue={n => n + ':'}
                                />
                                <AnimatedNumber
                                    component="span"
                                    value={clock_seconds}
                                    style={{
                                        transition: '0.8s ease-out',
                                        transitionProperty: 'opacity',
                                    }}
                                    stepPrecision={0}
                                    duration={500}
                                    formatValue={n => (n <= 9 ? '0' + n : n)}
                                />
                            </span>
                        )}
                    </div>
                    <div className="team">
                        <img
                            src={removeSpecialChars(game.visiting_team.img_url_90)}
                            alt={game.visiting_team.short_name + ' logo'}
                        />
                        <div className="team_name">
                            {overrideTeamTricode(game.visiting_team.short_name)}
                        </div>
                        <div className="score">
                            <CSSTransitionGroup
                                transitionName="ticker__scoreani"
                                transitionEnterTimeout={525}
                                transitionLeaveTimeout={275}
                            >
                                <div key={game.visiting_team.score || 0}>
                                    {game.game_status === 'In-Progress' ||
                                    game.game_status === 'Final'
                                        ? game.visiting_team.score
                                        : ''}
                                </div>
                            </CSSTransitionGroup>
                        </div>
                    </div>
                    <div className="team">
                        <img
                            src={removeSpecialChars(game.home_team.img_url_90)}
                            alt={game.home_team.short_name + ' logo'}
                        />
                        <div className="team_name">
                            {overrideTeamTricode(game.home_team.short_name)}
                        </div>
                        <div className="score">
                            <CSSTransitionGroup
                                transitionName="ticker__scoreani"
                                transitionEnterTimeout={525}
                                transitionLeaveTimeout={275}
                            >
                                <div key={game.home_team.score || 0}>
                                    {game.game_status === 'In-Progress' ||
                                    game.game_status === 'Final'
                                        ? game.home_team.score
                                        : ''}
                                </div>
                            </CSSTransitionGroup>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }
}

export default TickerGame
